<template>
    <div class="app-inner">
        <div class="main">
            <div class="panel">
                <div class="header">
                    <h1>很抱歉，您要访问的页面不存在</h1>
                </div>
                <div class="body" style="font-size: 15px">
                    <p>1.您在地址中可能存在键入错误.</p>
                    <p>2.当您点击某个链接时，他可能已经过期.</p>
                    <p>&nbsp;</p>
                    <p>您可以尝试以下操作.</p>
                    <p>
                        <a id="back-link" @click="xTo('/')">← 返回首页</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-inner{
    overflow: hidden;
}
.panel {
    background: #eee;
    padding: 40px 60px;
    border-radius: 6px;
    width: 40em;
    margin: 0 auto;
    margin-top: 200px;
    max-width: 100%;
}
a, a:link, a:active, a:visited {
    cursor: pointer;
    color: #00c7b7;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/notfound.vue